import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.contracts.title',
        defaultMessage: 'Contracts'
    },
    dateColHeader: {
        id: '_.contracts.dateColHeader',
        defaultMessage: 'Signed Date'
    },
    typeColHeader: {
        id: '_.contracts.typeColHeader',
        defaultMessage: 'Document Type'
    },
    download: {
        id: '_.contracts.download',
        defaultMessage: 'Download'
    },
    agreement: {
        id: '_.contracts.agreement',
        defaultMessage: 'Agreement'
    },
    guarantee: {
        id: '_.contracts.guarantee',
        defaultMessage: 'Guarantee'
    },
    otherDoc: {
        id: '_.contracts.otherDoc',
        defaultMessage: 'Other Document'
    }
});
